<template>
  <div class="parallax">
    <div class="darker-overlay">
      <div class="container">
        <div class="extra-info">
          <h2 class="font-4 color-3 extra-info__title">{{ htaTitle }}</h2>
          <p class="font-4 color-3 extra-info__description">{{ htaDescription }}</p>
          <a href="tel:+34 932 31 77 16" class="btn btn-primary extra-info__btn">
            <i class="fas fa-phone"></i> Reserve
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Parallex",
  computed: {
    htaTitle() {
      return this.getHtaData().title;
    },
    htaDescription() {
      return this.getHtaData().description;
    },
  },
  methods: {
    getHtaData() {
      return this.$store.getters.currentData.salaSection;
    },
  },
};
</script>

<style lang="scss">
.parallax {
  background-image: url("../../assets/img/hall.jpg");
  min-height: 500px;
  position: relative;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin-top: 76px;

  @media only screen and (max-width: 800px) {
    background-attachment: scroll;
  }
}

.darker-overlay {
  background-color: rgba(0, 0, 0, 0.7);
  padding: 250px 0;
}

.extra-info {
  color: white;
  text-align: left;
  text-shadow: 1px 1px 2px #a42e0e;
  font-weight: bolder;
  font-size: 1.5rem;

  @media only screen and (min-width: 800px) {
    font-size: 2rem;
    width: 60%;
  }

  &__btn {
    background-color: #0b658f !important;
    margin-top: 1rem;
  }

  &__title {
    font-size: 36px;
    @media only screen and (min-width: 800px) {
      font-size: 46px;
    }
  }

  &__description {
    font-size: 20px;
    @media only screen and (min-width: 800px) {
      font-size: 24px;
    }
  }
}
</style>
